import { safeExecute, } from "@opendaw/lib-std";
import { Box, NoPointers, PointerField, StringField, BooleanField, Field, } from "@opendaw/lib-box";
import { Pointers } from "@opendaw/studio-enums";
export class CompositeDeviceBox extends Box {
    static create(graph, uuid, constructor) {
        return graph.stageBox(new CompositeDeviceBox({
            uuid,
            graph,
            name: "CompositeDeviceBox",
            pointerRules: {
                accepts: [
                    Pointers.Device,
                    Pointers.Selection,
                    Pointers.MetaData,
                    Pointers.SideChain,
                ],
                mandatory: false,
                exclusive: false,
            },
            resource: undefined,
            ephemeral: false,
        }), constructor);
    }
    static ClassName = "CompositeDeviceBox";
    static Resource = undefined;
    static Ephemeral = false;
    static Tags = Object.freeze({
        type: "device",
        deviceType: "instrument",
        content: "notes",
    });
    constructor(construct) {
        super(construct);
    }
    accept(visitor) {
        return safeExecute(visitor.visitCompositeDeviceBox, this);
    }
    get tags() {
        return CompositeDeviceBox.Tags;
    }
    get host() {
        return this.getField(1);
    }
    get label() {
        return this.getField(2);
    }
    get icon() {
        return this.getField(3);
    }
    get enabled() {
        return this.getField(4);
    }
    get minimized() {
        return this.getField(5);
    }
    get cells() {
        return this.getField(10);
    }
    initializeFields() {
        return {
            1: PointerField.create({
                parent: this,
                fieldKey: 1,
                fieldName: "host",
                deprecated: false,
                pointerRules: NoPointers,
            }, Pointers.InstrumentHost, true),
            2: StringField.create({
                parent: this,
                fieldKey: 2,
                fieldName: "label",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            3: StringField.create({
                parent: this,
                fieldKey: 3,
                fieldName: "icon",
                deprecated: false,
                pointerRules: NoPointers,
            }),
            4: BooleanField.create({
                parent: this,
                fieldKey: 4,
                fieldName: "enabled",
                deprecated: false,
                pointerRules: NoPointers,
            }, true),
            5: BooleanField.create({
                parent: this,
                fieldKey: 5,
                fieldName: "minimized",
                deprecated: false,
                pointerRules: NoPointers,
            }, false),
            10: Field.hook({
                parent: this,
                fieldKey: 10,
                fieldName: "cells",
                deprecated: false,
                pointerRules: {
                    accepts: [Pointers.CompositeCell],
                    mandatory: false,
                    exclusive: false,
                },
            }),
        };
    }
}
